var moduleMap = {
	"./Pages": () => {
		return Promise.all([__webpack_require__.e(916), __webpack_require__.e(5053), __webpack_require__.e(7057), __webpack_require__.e(3197), __webpack_require__.e(3505), __webpack_require__.e(6176), __webpack_require__.e(1442), __webpack_require__.e(2427), __webpack_require__.e(768), __webpack_require__.e(895), __webpack_require__.e(3692), __webpack_require__.e(3936), __webpack_require__.e(2324), __webpack_require__.e(5528), __webpack_require__.e(6797), __webpack_require__.e(4712), __webpack_require__.e(3909), __webpack_require__.e(2370), __webpack_require__.e(2139), __webpack_require__.e(4406), __webpack_require__.e(8818), __webpack_require__.e(2632), __webpack_require__.e(3297), __webpack_require__.e(6949), __webpack_require__.e(6638), __webpack_require__.e(8495), __webpack_require__.e(6254), __webpack_require__.e(2505), __webpack_require__.e(246), __webpack_require__.e(8597), __webpack_require__.e(7170), __webpack_require__.e(7875), __webpack_require__.e(5570), __webpack_require__.e(3834), __webpack_require__.e(2927), __webpack_require__.e(2893), __webpack_require__.e(1387)]).then(() => (() => ((__webpack_require__(22279)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});